import { Component } from '@angular/core';

@Component({
    selector: 'my-app-layout',
    template: require('./layout.component.html'),
})
export class LayoutComponent {
    constructor(){}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/layout.component.ts